import React, { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Extract language from URL path (/en, /fr, /es)
  const getLanguageFromPath = () => {
    const path = location.pathname;
    if (path.startsWith('/fr')) return 'fr';
    if (path.startsWith('/es')) return 'es';
    return 'en'; // Default to English
  };

  const [language, setLanguage] = useState(getLanguageFromPath());

  // Update language when URL changes
  useEffect(() => {
    const newLang = getLanguageFromPath();
    if (newLang !== language) {
      setLanguage(newLang);
    }
  }, [location.pathname]);

  const changeLanguage = (newLang) => {
    setLanguage(newLang);
    navigate(`/${newLang}`);
  };

  const value = {
    language,
    changeLanguage,
    availableLanguages: [
      { code: 'en', name: 'English', flag: '🇺🇸' },
      { code: 'fr', name: 'Français', flag: '🇫🇷' },
      { code: 'es', name: 'Español', flag: '🇪🇸' }
    ]
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
